var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3C0E86BB-DDE7-4248-9F28-814B4353179D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meu-perfil",
    transform: "translate(-312.000000, -223.000000)",
    fill: "#B4B4B4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-(2)",
    transform: "translate(312.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,8.5 C3,8.7761399 2.7761399,9 2.5,9 C2.2238601,9 2,8.7761399 2,8.5 C2,8.2238601 2.2238601,8 2.5,8 C2.7761399,8 3,8.2238601 3,8.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,7 C2.70776788,7 2.47059584,6.78121273 2.47059584,6.51163345 L2.47059584,5.85396015 C2.47059584,5.23408278 2.89698851,4.67858967 3.53082591,4.47220233 C4.37430527,4.19809232 4.94119168,3.36908535 4.94119168,2.76745018 C4.94119168,1.77962869 4.07082848,0.976733093 3,0.976733093 C1.92917152,0.976733093 1.05880832,1.77962869 1.05880832,2.76745018 C1.05880832,3.03702946 0.821636283,3.25581673 0.52940416,3.25581673 C0.237172038,3.25581673 0,3.03702946 0,2.76745018 C0,1.24178164 1.34548276,0 3,0 C4.65451724,0 6,1.24178164 6,2.76745018 C6,3.85363653 5.07031147,5.00683019 3.8830296,5.39361265 C3.67131961,5.46193153 3.52940416,5.64745359 3.52940416,5.85455629 L3.52940416,6.51163345 C3.52940416,6.78121273 3.29223212,7 3,7 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,17 C3.812912,17 0,13.187088 0,8.5 C0,3.812912 3.812912,0 8.5,0 C13.187088,0 17,3.812912 17,8.5 C17,13.187088 13.187088,17 8.5,17 Z M8.5,1.0625 C4.39876557,1.0625 1.0625,4.39876557 1.0625,8.5 C1.0625,12.6012344 4.39876557,15.9375 8.5,15.9375 C12.6012344,15.9375 15.9375,12.6012344 15.9375,8.5 C15.9375,4.39876557 12.6012344,1.0625 8.5,1.0625 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c7349c1e2c2340429e621ba36b354248.svg";
export { ForwardRef as ReactComponent };